(function () {
  function hoverMainMenu() {
    var self = this;
    this.init = function (obj, e) {
      var subMenu = $('#' + obj.dataset.child);
      var mainMenu = $('.' + obj.dataset.parent);

      this.obeserveNav(subMenu);
      var imageCategory = $('.submenu-wrap.open').find(
        '.image-wrap .image_menu_container',
      );

      var defaultMedia = imageCategory.attr('default_image');
      imageCategory.css('background-image', 'url(' + defaultMedia + ')');
      if (this.checkIfExist(subMenu)) {
        this.openSubMenu(subMenu, mainMenu);
      } else {
        this.clearAllMenu();
      }
    };

    this.clearAllMenu = function () {
      $('.linktoactive').each(function () {
        $(this).removeClass('current');
      });

      $('.main_menu_link').attr('aria-expanded', 'false');
      $('.submenu-wrap').attr('aria-hidden', 'true');

      $('.submenu-wrap').each(function () {
        $(this).find('.submenu').addClass('invisible');
        $(this).find('.op').addClass('hide');
        $(this).addClass('hide');
        $(this).removeClass('open');
      });
    };

    this.openSubMenu = function (submenu, mainMenu) {
      if (submenu.hasClass('open')) return;
      this.clearAllMenu();

      mainMenu.attr('aria-expanded', 'true');
      submenu.attr('aria-hidden', 'false');

      mainMenu.find('a').addClass('current');
      submenu.addClass('open');
      submenu.removeClass('hide');
      submenu.find('.submenu_lvl0').removeClass('invisible');
      submenu.find('.image-wrap').removeClass('invisible');

      var level2Links = submenu.find('.submenu_lvl0').find('.submenu_link');
      if (level2Links.length) {
        level2Links.first().trigger('open.menu.oc');
      }
    };

    this.checkIfExist = function (submenu) {
      if (submenu[0]) {
        return true;
      }
      return false;
    };

    this.obeserveNav = function (obj) {
      $(obj)
        .mouseenter(function () {})
        .mouseleave(function () {
          self.clearAllMenu();
        });
    };
  }

  var menuHandler = new hoverMainMenu();

  $('.main_menu_link').on('mouseenter focusin', function (e) {
    var menu_mobile = 1375;
    if (jQuery(window).outerWidth(true) > menu_mobile) {
      menuHandler.init(this, e);
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      menuHandler.clearAllMenu();
    }
  });

  $('body').on('focusin', function (e) {
    if ($(e.target).closest('.header-menu, .main-menu').length === 0) {
      menuHandler.clearAllMenu();
    }
  });
})();

$(document).ready(function () {
  $('.main_menu_link_item').on('keydown', function (e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      var parentLi = $(this).closest('.main_menu_link');
      var childId = parentLi.attr('data-child');
      var subMenu = $('#' + childId);

      if (subMenu.length > 0 && subMenu.hasClass('open')) {
        e.preventDefault();
        var firstLink = subMenu.find('a:visible').first();
        firstLink.focus();
      }
    }
  });

  $('.submenu-wrap').each(function () {
    var submenu = $(this);
    var allLinks = submenu.find('a');

    if (allLinks.length === 0) return;

    var lastLink = allLinks.last();
    var firstLink = allLinks.first();

    lastLink.on('keydown', function (e) {
      if ($(this).is(':visible') && e.key === 'Tab' && !e.shiftKey) {
        var menuId = submenu.attr('id');
        var parentTrigger = $('.main_menu_link[data-child="' + menuId + '"]');

        var nextMainLi = parentTrigger.next('.main_menu_link');
        var nextMainLink = nextMainLi.find('a.main_menu_link_item');

        if (nextMainLink.length > 0) {
          e.preventDefault();
          nextMainLink.focus();
        } else {
          var menuContainer = $('.menu-wrap');
          var nextContainer = menuContainer.next();
          var targetElement = nextContainer
            .find('a, button, input')
            .filter(':visible')
            .first();

          if (targetElement.length > 0) {
            e.preventDefault();
            targetElement.focus();

            $('.submenu-wrap')
              .removeClass('open')
              .addClass('hide')
              .attr('aria-hidden', 'true');
            $('.main_menu_link').attr('aria-expanded', 'false');
          }
        }
      }
    });

    firstLink.on('keydown', function (e) {
      if ($(this).is(':visible') && e.key === 'Tab' && e.shiftKey) {
        var menuId = submenu.attr('id');
        var parentTriggerLink = $(
          '.main_menu_link[data-child="' + menuId + '"] > a',
        );

        if (parentTriggerLink.length > 0) {
          e.preventDefault();
          parentTriggerLink.focus();
        }
      }
    });
  });
});
